import React, { forwardRef } from 'react';
import { IconButton } from './icon-button';
import { LinkButton } from './link-button';
import { RegularButton } from './regular-button';
import { BaseButton } from './base-button';
/**
 * `<Button />` —  базовый компонент с различными функциями.
 *
 * @deprecated компонент был разделен на отдельные `RegularButton`, `LinkButton` и `IconButton`. В будущем компонент будет заменен на `RegularButton`
 *
 * @example ```tsx
 * <Button>TEXT</Button>
 * ```
 */
export const Button = /*#__PURE__*/forwardRef(function Button({
  kind,
  ...props
}, ref) {
  switch (kind) {
    case 'regular':
      {
        return /*#__PURE__*/React.createElement(RegularButton, {
          ref: ref,
          ...props
        });
      }
    case 'link':
      {
        return /*#__PURE__*/React.createElement(LinkButton, {
          ref: ref,
          ...props
        });
      }
    case 'icon':
      {
        return /*#__PURE__*/React.createElement(IconButton, {
          ref: ref,
          ...props
        });
      }
    default:
      {
        return /*#__PURE__*/React.createElement(BaseButton, {
          ref: ref,
          ...props
        });
      }
  }
});